var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDivide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.93945L7.71973 6.21973L8.78027 7.28027L11.25 4.81055V9.75H0V11.25H24V9.75H12.75V4.81055L15.2197 7.28027L16.2803 6.21973L12 1.93945ZM0 12.75V14.25H11.25V19.1895L8.78027 16.7197L7.71973 17.7803L12 22.0605L16.2803 17.7803L15.2197 16.7197L12.75 19.1895V14.25H24V12.75H0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivide);
export default __webpack_public_path__ + "static/media/divide.561c302be7961a97dc68a2493f985480.svg";
export { ForwardRef as ReactComponent };